'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _email = require('../../../email');

var _email2 = _interopRequireDefault(_email);

var _phonenumber = require('../../../phonenumber');

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _languageHandler = require('../../../languageHandler');

var _SdkConfig = require('../../../SdkConfig');

var _SdkConfig2 = _interopRequireDefault(_SdkConfig);

var _Registration = require('../../../Registration');

var _Validation = require('../elements/Validation');

var _Validation2 = _interopRequireDefault(_Validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2015, 2016 OpenMarket Ltd
Copyright 2017 Vector Creations Ltd
Copyright 2018, 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var FIELD_EMAIL = 'field_email';
var FIELD_PHONE_NUMBER = 'field_phone_number';
var FIELD_USERNAME = 'field_username';
var FIELD_PASSWORD = 'field_password';
var FIELD_PASSWORD_CONFIRM = 'field_password_confirm';

var PASSWORD_MIN_SCORE = 3; // safely unguessable: moderate protection from offline slow-hash scenario.

/**
 * A pure UI component which displays a registration form.
 */
module.exports = _react2.default.createClass({
    displayName: 'RegistrationForm',

    propTypes: {
        // Values pre-filled in the input boxes when the component loads
        defaultEmail: _propTypes2.default.string,
        defaultPhoneCountry: _propTypes2.default.string,
        defaultPhoneNumber: _propTypes2.default.string,
        defaultUsername: _propTypes2.default.string,
        defaultPassword: _propTypes2.default.string,
        onRegisterClick: _propTypes2.default.func.isRequired, // onRegisterClick(Object) => ?Promise
        onEditServerDetailsClick: _propTypes2.default.func,
        flows: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
        // This is optional and only set if we used a server name to determine
        // the HS URL via `.well-known` discovery. The server name is used
        // instead of the HS URL when talking about "your account".
        hsName: _propTypes2.default.string,
        hsUrl: _propTypes2.default.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            onValidationChange: console.error
        };
    },

    getInitialState: function getInitialState() {
        return {
            // Field error codes by field ID
            fieldValid: {},
            // The ISO2 country code selected in the phone number entry
            phoneCountry: this.props.defaultPhoneCountry,
            username: "",
            email: "",
            phoneNumber: "",
            password: "",
            passwordConfirm: "",
            passwordComplexity: null,
            passwordSafe: false
        };
    },

    onSubmit: function () {
        var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(ev) {
            var allFieldsValid, self, QuestionDialog;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            ev.preventDefault();

                            _context.next = 3;
                            return (0, _bluebird.resolve)(this.verifyFieldsBeforeSubmit());

                        case 3:
                            allFieldsValid = _context.sent;

                            if (allFieldsValid) {
                                _context.next = 6;
                                break;
                            }

                            return _context.abrupt('return');

                        case 6:
                            self = this;

                            if (this.state.email == '') {
                                QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");

                                _Modal2.default.createTrackedDialog('If you don\'t specify an email address...', '', QuestionDialog, {
                                    title: (0, _languageHandler._t)("Warning!"),
                                    description: _react2.default.createElement(
                                        'div',
                                        null,
                                        (0, _languageHandler._t)("If you don't specify an email address, you won't be able to reset your password. " + "Are you sure?")
                                    ),
                                    button: (0, _languageHandler._t)("Continue"),
                                    onFinished: function onFinished(confirmed) {
                                        if (confirmed) {
                                            self._doSubmit(ev);
                                        }
                                    }
                                });
                            } else {
                                self._doSubmit(ev);
                            }

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onSubmit(_x) {
            return _ref.apply(this, arguments);
        }

        return onSubmit;
    }(),

    _doSubmit: function _doSubmit(ev) {
        var email = this.state.email.trim();
        var promise = this.props.onRegisterClick({
            username: this.state.username.trim(),
            password: this.state.password.trim(),
            email: email,
            phoneCountry: this.state.phoneCountry,
            phoneNumber: this.state.phoneNumber
        });

        if (promise) {
            ev.target.disabled = true;
            promise.finally(function () {
                ev.target.disabled = false;
            });
        }
    },

    verifyFieldsBeforeSubmit: function verifyFieldsBeforeSubmit() {
        var _this = this;

        return (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var activeElement, fieldIDsInDisplayOrder, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, fieldID, field, invalidField;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            // Blur the active element if any, so we first run its blur validation,
                            // which is less strict than the pass we're about to do below for all fields.
                            activeElement = document.activeElement;

                            if (activeElement) {
                                activeElement.blur();
                            }

                            fieldIDsInDisplayOrder = [FIELD_USERNAME, FIELD_PASSWORD, FIELD_PASSWORD_CONFIRM, FIELD_EMAIL, FIELD_PHONE_NUMBER];

                            // Run all fields with stricter validation that no longer allows empty
                            // values for required fields.

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 6;
                            _iterator = (0, _getIterator3.default)(fieldIDsInDisplayOrder);

                        case 8:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context2.next = 18;
                                break;
                            }

                            fieldID = _step.value;
                            field = _this[fieldID];

                            if (field) {
                                _context2.next = 13;
                                break;
                            }

                            return _context2.abrupt('continue', 15);

                        case 13:
                            _context2.next = 15;
                            return (0, _bluebird.resolve)(field.validate({ allowEmpty: false }));

                        case 15:
                            _iteratorNormalCompletion = true;
                            _context2.next = 8;
                            break;

                        case 18:
                            _context2.next = 24;
                            break;

                        case 20:
                            _context2.prev = 20;
                            _context2.t0 = _context2['catch'](6);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                        case 24:
                            _context2.prev = 24;
                            _context2.prev = 25;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 27:
                            _context2.prev = 27;

                            if (!_didIteratorError) {
                                _context2.next = 30;
                                break;
                            }

                            throw _iteratorError;

                        case 30:
                            return _context2.finish(27);

                        case 31:
                            return _context2.finish(24);

                        case 32:
                            _context2.next = 34;
                            return (0, _bluebird.resolve)(new _promise2.default(function (resolve) {
                                return _this.setState({}, resolve);
                            }));

                        case 34:
                            if (!_this.allFieldsValid()) {
                                _context2.next = 36;
                                break;
                            }

                            return _context2.abrupt('return', true);

                        case 36:
                            invalidField = _this.findFirstInvalidField(fieldIDsInDisplayOrder);

                            if (invalidField) {
                                _context2.next = 39;
                                break;
                            }

                            return _context2.abrupt('return', true);

                        case 39:

                            // Focus the first invalid field and show feedback in the stricter mode
                            // that no longer allows empty values for required fields.
                            invalidField.focus();
                            invalidField.validate({ allowEmpty: false, focused: true });
                            return _context2.abrupt('return', false);

                        case 42:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[6, 20, 24, 32], [25,, 27, 31]]);
        }))();
    },


    /**
     * @returns {boolean} true if all fields were valid last time they were validated.
     */
    allFieldsValid: function allFieldsValid() {
        var keys = (0, _keys2.default)(this.state.fieldValid);
        for (var i = 0; i < keys.length; ++i) {
            if (!this.state.fieldValid[keys[i]]) {
                return false;
            }
        }
        return true;
    },

    findFirstInvalidField: function findFirstInvalidField(fieldIDs) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = (0, _getIterator3.default)(fieldIDs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var fieldID = _step2.value;

                if (!this.state.fieldValid[fieldID] && this[fieldID]) {
                    return this[fieldID];
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return null;
    },


    markFieldValid: function markFieldValid(fieldID, valid) {
        var fieldValid = this.state.fieldValid;

        fieldValid[fieldID] = valid;
        this.setState({
            fieldValid: fieldValid
        });
    },

    onEmailChange: function onEmailChange(ev) {
        this.setState({
            email: ev.target.value
        });
    },
    onEmailValidate: function onEmailValidate(fieldState) {
        var _this2 = this;

        return (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var result;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return (0, _bluebird.resolve)(_this2.validateEmailRules(fieldState));

                        case 2:
                            result = _context3.sent;

                            _this2.markFieldValid(FIELD_EMAIL, result.valid);
                            return _context3.abrupt('return', result);

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2);
        }))();
    },


    validateEmailRules: (0, _Validation2.default)({
        description: function description() {
            return (0, _languageHandler._t)("Use an email address to recover your account");
        },
        rules: [{
            key: "required",
            test: function test(_ref2) {
                var value = _ref2.value,
                    allowEmpty = _ref2.allowEmpty;

                return allowEmpty || !this._authStepIsRequired('m.login.email.identity') || !!value;
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Enter email address (required on this homeserver)");
            }
        }, {
            key: "email",
            test: function test(_ref3) {
                var value = _ref3.value;
                return !value || _email2.default.looksValid(value);
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Doesn't look like a valid email address");
            }
        }]
    }),

    onPasswordChange: function onPasswordChange(ev) {
        this.setState({
            password: ev.target.value
        });
    },
    onPasswordValidate: function onPasswordValidate(fieldState) {
        var _this3 = this;

        return (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var result;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return (0, _bluebird.resolve)(_this3.validatePasswordRules(fieldState));

                        case 2:
                            result = _context4.sent;

                            _this3.markFieldValid(FIELD_PASSWORD, result.valid);
                            return _context4.abrupt('return', result);

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this3);
        }))();
    },


    validatePasswordRules: (0, _Validation2.default)({
        description: function description() {
            var complexity = this.state.passwordComplexity;
            var score = complexity ? complexity.score : 0;
            return _react2.default.createElement('progress', {
                className: 'mx_AuthBody_passwordScore',
                max: PASSWORD_MIN_SCORE,
                value: score
            });
        },
        rules: [{
            key: "required",
            test: function test(_ref4) {
                var value = _ref4.value,
                    allowEmpty = _ref4.allowEmpty;
                return allowEmpty || !!value;
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Enter password");
            }
        }, {
            key: "complexity",
            test: function () {
                var _ref5 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(_ref6) {
                    var value = _ref6.value;

                    var _ref7, scorePassword, complexity, safe, allowUnsafe;

                    return _regenerator2.default.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    if (value) {
                                        _context5.next = 2;
                                        break;
                                    }

                                    return _context5.abrupt('return', false);

                                case 2:
                                    _context5.next = 4;
                                    return (0, _bluebird.resolve)(import('../../../utils/PasswordScorer'));

                                case 4:
                                    _ref7 = _context5.sent;
                                    scorePassword = _ref7.scorePassword;
                                    complexity = scorePassword(value);
                                    safe = complexity.score >= PASSWORD_MIN_SCORE;
                                    allowUnsafe = _SdkConfig2.default.get()["dangerously_allow_unsafe_and_insecure_passwords"];

                                    this.setState({
                                        passwordComplexity: complexity,
                                        passwordSafe: safe
                                    });
                                    return _context5.abrupt('return', allowUnsafe || safe);

                                case 11:
                                case 'end':
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, this);
                }));

                function test(_x2) {
                    return _ref5.apply(this, arguments);
                }

                return test;
            }(),
            valid: function valid() {
                // Unsafe passwords that are valid are only possible through a
                // configuration flag. We'll print some helper text to signal
                // to the user that their password is allowed, but unsafe.
                if (!this.state.passwordSafe) {
                    return (0, _languageHandler._t)("Password is allowed, but unsafe");
                }
                return (0, _languageHandler._t)("Nice, strong password!");
            },
            invalid: function invalid() {
                var complexity = this.state.passwordComplexity;
                if (!complexity) {
                    return null;
                }
                var feedback = complexity.feedback;

                return feedback.warning || feedback.suggestions[0] || (0, _languageHandler._t)("Keep going...");
            }
        }]
    }),

    onPasswordConfirmChange: function onPasswordConfirmChange(ev) {
        this.setState({
            passwordConfirm: ev.target.value
        });
    },
    onPasswordConfirmValidate: function onPasswordConfirmValidate(fieldState) {
        var _this4 = this;

        return (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
            var result;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return (0, _bluebird.resolve)(_this4.validatePasswordConfirmRules(fieldState));

                        case 2:
                            result = _context6.sent;

                            _this4.markFieldValid(FIELD_PASSWORD_CONFIRM, result.valid);
                            return _context6.abrupt('return', result);

                        case 5:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this4);
        }))();
    },


    validatePasswordConfirmRules: (0, _Validation2.default)({
        rules: [{
            key: "required",
            test: function test(_ref8) {
                var value = _ref8.value,
                    allowEmpty = _ref8.allowEmpty;
                return allowEmpty || !!value;
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Confirm password");
            }
        }, {
            key: "match",
            test: function test(_ref9) {
                var value = _ref9.value;

                return !value || value === this.state.password;
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Passwords don't match");
            }
        }]
    }),

    onPhoneCountryChange: function onPhoneCountryChange(newVal) {
        this.setState({
            phoneCountry: newVal.iso2,
            phonePrefix: newVal.prefix
        });
    },
    onPhoneNumberChange: function onPhoneNumberChange(ev) {
        this.setState({
            phoneNumber: ev.target.value
        });
    },
    onPhoneNumberValidate: function onPhoneNumberValidate(fieldState) {
        var _this5 = this;

        return (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            var result;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.next = 2;
                            return (0, _bluebird.resolve)(_this5.validatePhoneNumberRules(fieldState));

                        case 2:
                            result = _context7.sent;

                            _this5.markFieldValid(FIELD_PHONE_NUMBER, result.valid);
                            return _context7.abrupt('return', result);

                        case 5:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this5);
        }))();
    },


    validatePhoneNumberRules: (0, _Validation2.default)({
        description: function description() {
            return (0, _languageHandler._t)("Other users can invite you to rooms using your contact details");
        },
        rules: [{
            key: "required",
            test: function test(_ref10) {
                var value = _ref10.value,
                    allowEmpty = _ref10.allowEmpty;

                return allowEmpty || !this._authStepIsRequired('m.login.msisdn') || !!value;
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Enter phone number (required on this homeserver)");
            }
        }, {
            key: "email",
            test: function test(_ref11) {
                var value = _ref11.value;
                return !value || (0, _phonenumber.looksValid)(value);
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Doesn't look like a valid phone number");
            }
        }]
    }),

    onUsernameChange: function onUsernameChange(ev) {
        this.setState({
            username: ev.target.value
        });
    },
    onUsernameValidate: function onUsernameValidate(fieldState) {
        var _this6 = this;

        return (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
            var result;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return (0, _bluebird.resolve)(_this6.validateUsernameRules(fieldState));

                        case 2:
                            result = _context8.sent;

                            _this6.markFieldValid(FIELD_USERNAME, result.valid);
                            return _context8.abrupt('return', result);

                        case 5:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this6);
        }))();
    },


    validateUsernameRules: (0, _Validation2.default)({
        description: function description() {
            return (0, _languageHandler._t)("Use letters, numbers, dashes and underscores only");
        },
        rules: [{
            key: "required",
            test: function test(_ref12) {
                var value = _ref12.value,
                    allowEmpty = _ref12.allowEmpty;
                return allowEmpty || !!value;
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Enter username");
            }
        }, {
            key: "safeLocalpart",
            test: function test(_ref13) {
                var value = _ref13.value;
                return !value || _Registration.SAFE_LOCALPART_REGEX.test(value);
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Some characters not allowed");
            }
        }]
    }),

    /**
     * A step is required if all flows include that step.
     *
     * @param {string} step A stage name to check
     * @returns {boolean} Whether it is required
     */
    _authStepIsRequired: function _authStepIsRequired(step) {
        return this.props.flows.every(function (flow) {
            return flow.stages.includes(step);
        });
    },


    /**
     * A step is used if any flows include that step.
     *
     * @param {string} step A stage name to check
     * @returns {boolean} Whether it is used
     */
    _authStepIsUsed: function _authStepIsUsed(step) {
        return this.props.flows.some(function (flow) {
            return flow.stages.includes(step);
        });
    },
    renderEmail: function renderEmail() {
        var _this7 = this;

        if (!this._authStepIsUsed('m.login.email.identity')) {
            return null;
        }
        var Field = _index2.default.getComponent('elements.Field');
        var emailPlaceholder = this._authStepIsRequired('m.login.email.identity') ? (0, _languageHandler._t)("Email") : (0, _languageHandler._t)("Email (optional)");
        return _react2.default.createElement(Field, {
            id: 'mx_RegistrationForm_email',
            ref: function ref(field) {
                return _this7[FIELD_EMAIL] = field;
            },
            type: 'text',
            label: emailPlaceholder,
            defaultValue: this.props.defaultEmail,
            value: this.state.email,
            onChange: this.onEmailChange,
            onValidate: this.onEmailValidate
        });
    },
    renderPassword: function renderPassword() {
        var _this8 = this;

        var Field = _index2.default.getComponent('elements.Field');
        return _react2.default.createElement(Field, {
            id: 'mx_RegistrationForm_password',
            ref: function ref(field) {
                return _this8[FIELD_PASSWORD] = field;
            },
            type: 'password',
            label: (0, _languageHandler._t)("Password"),
            defaultValue: this.props.defaultPassword,
            value: this.state.password,
            onChange: this.onPasswordChange,
            onValidate: this.onPasswordValidate
        });
    },
    renderPasswordConfirm: function renderPasswordConfirm() {
        var _this9 = this;

        var Field = _index2.default.getComponent('elements.Field');
        return _react2.default.createElement(Field, {
            id: 'mx_RegistrationForm_passwordConfirm',
            ref: function ref(field) {
                return _this9[FIELD_PASSWORD_CONFIRM] = field;
            },
            type: 'password',
            label: (0, _languageHandler._t)("Confirm"),
            defaultValue: this.props.defaultPassword,
            value: this.state.passwordConfirm,
            onChange: this.onPasswordConfirmChange,
            onValidate: this.onPasswordConfirmValidate
        });
    },
    renderPhoneNumber: function renderPhoneNumber() {
        var _this10 = this;

        var threePidLogin = !_SdkConfig2.default.get().disable_3pid_login;
        if (!threePidLogin || !this._authStepIsUsed('m.login.msisdn')) {
            return null;
        }
        var CountryDropdown = _index2.default.getComponent('views.auth.CountryDropdown');
        var Field = _index2.default.getComponent('elements.Field');
        var phoneLabel = this._authStepIsRequired('m.login.msisdn') ? (0, _languageHandler._t)("Phone") : (0, _languageHandler._t)("Phone (optional)");
        var phoneCountry = _react2.default.createElement(CountryDropdown, {
            value: this.state.phoneCountry,
            isSmall: true,
            showPrefix: true,
            onOptionChange: this.onPhoneCountryChange
        });
        return _react2.default.createElement(Field, {
            id: 'mx_RegistrationForm_phoneNumber',
            ref: function ref(field) {
                return _this10[FIELD_PHONE_NUMBER] = field;
            },
            type: 'text',
            label: phoneLabel,
            defaultValue: this.props.defaultPhoneNumber,
            value: this.state.phoneNumber,
            prefix: phoneCountry,
            onChange: this.onPhoneNumberChange,
            onValidate: this.onPhoneNumberValidate
        });
    },
    renderUsername: function renderUsername() {
        var _this11 = this;

        var Field = _index2.default.getComponent('elements.Field');
        return _react2.default.createElement(Field, {
            id: 'mx_RegistrationForm_username',
            ref: function ref(field) {
                return _this11[FIELD_USERNAME] = field;
            },
            type: 'text',
            autoFocus: true,
            label: (0, _languageHandler._t)("Username"),
            defaultValue: this.props.defaultUsername,
            value: this.state.username,
            onChange: this.onUsernameChange,
            onValidate: this.onUsernameValidate
        });
    },


    render: function render() {
        var yourMatrixAccountText = (0, _languageHandler._t)('Create your Matrix account');
        if (this.props.hsName) {
            yourMatrixAccountText = (0, _languageHandler._t)('Create your Matrix account on %(serverName)s', {
                serverName: this.props.hsName
            });
        } else {
            try {
                var parsedHsUrl = new URL(this.props.hsUrl);
                yourMatrixAccountText = (0, _languageHandler._t)('Create your Matrix account on %(serverName)s', {
                    serverName: parsedHsUrl.hostname
                });
            } catch (e) {
                // ignore
            }
        }

        var editLink = null;
        if (this.props.onEditServerDetailsClick) {
            editLink = _react2.default.createElement(
                'a',
                { className: 'mx_AuthBody_editServerDetails',
                    href: '#', onClick: this.props.onEditServerDetailsClick
                },
                (0, _languageHandler._t)('Change')
            );
        }

        var registerButton = _react2.default.createElement('input', { className: 'mx_Login_submit', type: 'submit', value: (0, _languageHandler._t)("Register") });

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'h3',
                null,
                yourMatrixAccountText,
                editLink
            ),
            _react2.default.createElement(
                'form',
                { onSubmit: this.onSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_AuthBody_fieldRow' },
                    this.renderUsername()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_AuthBody_fieldRow' },
                    this.renderPassword(),
                    this.renderPasswordConfirm()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_AuthBody_fieldRow' },
                    this.renderEmail(),
                    this.renderPhoneNumber()
                ),
                (0, _languageHandler._t)("Use an email address to recover your account.") + " ",
                (0, _languageHandler._t)("Other users can invite you to rooms using your contact details."),
                registerButton
            )
        );
    }
});
//# sourceMappingURL=RegistrationForm.js.map